import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './i18n';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// 전역 CSS (wehago-conference에서 포팅)
import './assets/css/lux.css';
// import './assets/css/renewal.css'; // 해당 css는 사용하면 안됨 !
import './assets/css/rtc.css';
import './assets/css/rtc_m.css';
import './assets/css/error.css';
import './assets/css/customScroll.css';
import './assets/css/rtcCustoms.css';

// STT 테스트용 유틸리티 (콘솔에서 simulateTTS() 호출)
import './utils/simulateTTS';

// Recorder(Jibri) 모드일 때만 window.APP.conference 신호를 조기 노출한다.
// 일반 참여자 모드에서는 아무 동작도 하지 않는다.
import { installRecorderAppShim } from './utils/recorderMode';

installRecorderAppShim();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
);
